import IconButton from "@mui/material/IconButton";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import MenuItem from "@mui/material/MenuItem";
import Popover from "@mui/material/Popover";
import Tooltip from "@mui/material/Tooltip";
import {useId} from "react";
import {useTranslation} from "react-i18next";
import {useServerTableContext} from "../ServerTableContext";
import {
    useServerTableToolbarContext,
    useServerTableToolbarItemContext
} from "../ServerTableToolbarContext";
import {defineServerTableToolbarItem} from "../ServerTableToolbarItem";
import {serverTableControlIconSx, serverTableControlSx} from "../constants";
import SortPanel from "./SortPanel";

const ServerTableSortComponent = () => {
    const {t} = useTranslation();
    const {table} = useServerTableContext();
    const popoverId = useId();
    const {activePanel, openPanel, closePanel} = useServerTableToolbarContext();
    const toolbarItem = useServerTableToolbarItemContext();
    const hasSortableColumn = table.getAllLeafColumns()
        .some(column => column.columnDef.meta?.isServerSortable === true);
    if (!hasSortableColumn) return null;

    const isOpen = activePanel?.type === 'sort';
    const openSort = (anchor: HTMLElement) => {
        toolbarItem.closeMenu();
        openPanel('sort', toolbarItem.menuAnchor ?? anchor);
    };

    return (
        <>
            {toolbarItem.presentation === 'menu' ? (
                <MenuItem onClick={event => openSort(event.currentTarget)}>
                    <SwapVertIcon fontSize="small" sx={{mr: 1, color: 'primary.main'}}/>
                    {t('Sort')}
                </MenuItem>
            ) : (
                <Tooltip title={t('Sort')}>
                    <IconButton
                        size="small"
                        color="primary"
                        data-dashboard-control=""
                        data-active={isOpen || undefined}
                        aria-label={t('Sort')}
                        aria-haspopup="dialog"
                        aria-expanded={isOpen}
                        aria-controls={isOpen ? popoverId : undefined}
                        onClick={event => openSort(event.currentTarget)}
                        sx={serverTableControlSx}
                    >
                        <SwapVertIcon sx={serverTableControlIconSx}/>
                    </IconButton>
                </Tooltip>
            )}

            <Popover
                open={isOpen}
                anchorEl={isOpen ? activePanel.anchor : null}
                onClose={closePanel}
                anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                transformOrigin={{vertical: 'top', horizontal: 'right'}}
                PaperProps={{id: popoverId, role: 'dialog', 'aria-label': t('Sort')}}
            >
                <SortPanel table={table} onClose={closePanel}/>
            </Popover>
        </>
    );
};

export const ServerTableSort = defineServerTableToolbarItem(ServerTableSortComponent);
